<!-- CaseStatusWidget.vue -->
<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { useCaseStore } from '@/store/app/case/detail/caseDetailStore'
  import { useRouter } from 'vue-router'
  import { format, parseISO } from 'date-fns'
  import { de } from 'date-fns/locale'

  const router = useRouter()

  // Get case data from store
  const caseStore = useCaseStore()
  const caseRecord = computed(() => caseStore.caseRecord)

  // Get the inquiry content - as mentioned, this should be the main content to display
  const inquiry = computed(() => caseRecord.value?.inquiry || '')

  // Format created date
  const formattedCreatedAt = computed(() => {
    if (!caseRecord.value?.created_at) return null
    const date = parseISO(caseRecord.value.created_at)
    return format(date, "d. MMMM yyyy 'um' HH:mm 'Uhr'", { locale: de })
  })

  // Navigate to KI Chat
  const viewKIChat = () => {
    if (caseRecord.value?.uuid) {
      router.push(`/cases/${caseRecord.value.uuid}/chat`)
    }
  }
</script>

<template>
  <div class="[contain:content]">
    <!-- Loading State -->
    <div
      v-if="!caseRecord"
      class="flex justify-center py-6"
    >
      <div
        class="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-purple-600"
      ></div>
    </div>

    <div
      v-else-if="!inquiry"
      class="flex flex-col items-center justify-center rounded-lg border border-gray-300 px-4 py-10 shadow-sm"
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="40"
          height="40"
          rx="8"
          fill="#F3E8FF"
        />
        <path
          d="M19 20H11M24 14H11M24 26H11M27 18L23 22M23 18L27 22"
          stroke="#7E22CE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p class="text-md mt-5 text-center text-gray-500">Keine Anfrage-Informationen verfügbar</p>
    </div>

    <!-- Inquiry Content -->
    <div v-else>
      <!-- Inquiry Summary -->
      <div class="mb-2">
        <div
          class="prose prose-sm max-w-none text-gray-700"
          v-html="inquiry"
        ></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  :deep(.prose) {
    line-height: 1.5;
  }

  :deep(.prose p) {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
</style>
